import { BooleanFeature } from "./BooleanFeature";
import { FeatureCell } from "./FeatureCell";
import { MappedFeature } from "./MappedFeature";
import { NumberFeature } from "./NumberFeature";
import { usePlans } from "./PlansContext";
import { StringFeature } from "./StringFeature";

interface PlanFeatureFlagProps {
  feature: string;
  mapper?: (value: number) => string;
  suffix?: string;
  title: string;
}

export const PlanFeatureFlag = ({
  title,
  feature,
  suffix,
  mapper,
}: PlanFeatureFlagProps) => {
  const { plans } = usePlans();

  const renderInnerContent = (isNumeric: boolean, featureValue: number) => {
    if (mapper) {
      return <MappedFeature value={mapper(featureValue)} />;
    }

    if (isNumeric) {
      return <NumberFeature value={featureValue} suffix={suffix} />;
    }

    return <BooleanFeature value={!!featureValue} />;
  };

  const renderPlanFeature = (plan: any) => {
    const featureValue = plan.plan_feature_flags[feature];
    const isNumeric = typeof featureValue === "number";

    return (
      <FeatureCell key={plan.id}>
        {renderInnerContent(isNumeric, featureValue)}
      </FeatureCell>
    );
  };

  return (
    <>
      <FeatureCell>
        <StringFeature className="pr-5" value={title} hideCheckIcon />
      </FeatureCell>
      {plans.map(renderPlanFeature)}
    </>
  );
};
